import React, { useCallback, useMemo } from "react";
import { Observable } from "@legendapp/state";
import { useValue } from "@legendapp/state/react";
import { Calendar } from "primereact/calendar";
import type { FormEvent } from "primereact/ts-helpers";
import type {
  DatepickerValue,
  DateRangeDropdownState,
} from "./types/DateRangeDropdown.types";
import { LOCALE } from "../../utils/PrimeReactConstants";

const DATE_FORMAT = "M d, yy";
const RANGE = "range";
const INPUT_HEIGHT = "2.654rem"; // TODO: Update when input field component gets implemented
const [DATEPICKER_LOCALE] = LOCALE.split("-"); // API only accepts 2-character locale

interface DateSelectorProps {
  minDate?: Date;
  maxDate?: Date;
  state$: Observable<DateRangeDropdownState>;
  width?: string;
}

const DateSelector = ({
  minDate,
  maxDate,
  state$,
  width,
}: DateSelectorProps) => {
  const datepickerDates = useValue(state$.datepickerDates);
  const style = useMemo(() => ({ width, height: INPUT_HEIGHT }), [width]);

  const handleDateChange = useCallback(
    (evt: FormEvent<DatepickerValue[]>) => {
      state$.datepickerDates.set(evt.value ?? []);
    },
    [state$.datepickerDates]
  );

  return (
    <Calendar
      autoFocus
      dateFormat={DATE_FORMAT}
      hideOnRangeSelection
      locale={DATEPICKER_LOCALE}
      maxDate={maxDate}
      minDate={minDate}
      onChange={handleDateChange}
      readOnlyInput
      selectionMode={RANGE}
      showIcon
      style={style}
      value={datepickerDates}
    />
  );
};

export default DateSelector;
